import {useMutation} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';

export function useCompleteTour() {
  return useMutation({
    mutationFn: () =>
      apiClient.post('users/me/tour-complete').then(r => r.data),
    onError: () => {
      // Guest user or network error — silently ignore
    },
  });
}
